export const QUERY_KEY = 'users';
export const ME_QUERY_KEY = 'me';
